"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingWeightsBodyParamsSchema = void 0;
const zod_1 = require("zod");
/**
 * A number schema, that also accepts strings as input and tries to parse them before validating.
 *
 * @param schema
 * @returns number value
 */
const transformNumericString = (val) => {
    if (typeof val === 'string') {
        return Number.parseFloat(val);
    }
    else if (typeof val === 'number') {
        return val;
    }
    return NaN;
};
const numericStringSchema = zod_1.z.string().or(zod_1.z.number()).transform(transformNumericString);
const WeightSchema = zod_1.z.object({
    respondent_id: zod_1.z.string().uuid(),
    weight: numericStringSchema,
    subarea_type: zod_1.z.string().nullish(),
    subarea_name: zod_1.z.string().nullish(),
    subarea_weight: numericStringSchema.nullish(),
});
exports.ReportingWeightsBodyParamsSchema = zod_1.z.object({
    polco_survey_id: zod_1.z.string().uuid(),
    weights: zod_1.z.array(WeightSchema),
    skip_weight_validation: zod_1.z.boolean().nullish(),
});
